export const BUILD_TIME_RENEWAL_ENABLED = false;

export const isRenewalEnabledSeller = (debugPanelRenewalEnabledSeller: boolean): boolean =>
  BUILD_TIME_RENEWAL_ENABLED || debugPanelRenewalEnabledSeller;

export const isRenewalEnabledBuyer = (debugToggle: boolean): boolean => BUILD_TIME_RENEWAL_ENABLED || debugToggle;
